import React, { useEffect, useId, useMemo } from "react";
import Icon from "../minicart/icon";
import { withMonogramContext } from "./MonogramContext";
import MonogramSettingHeader from "./MonogramSettingHeader";
import { MONOGRAM_POSITION_STYLES } from "./const";

function MonogramPositionDropdown({
  setPositionName,
  positionName,
  data,
  chosenFont,
  initialPageLoad,
  monogramDefaultPosition,
}) {
  const id = useId();

  // Use the monogram_disabled_positions metafield to filter positions
  const positions = useMemo(() => {
    const disabledPositions = (data.monogram_disabled_positions || "")
      .replace("\u0026", "&")
      .split("|");

    return Object.keys(MONOGRAM_POSITION_STYLES).filter(
      (position) => !disabledPositions.includes(position)
    );
  }, [data]);

  const handleSelectChange = (event) => {
    setPositionName(event.target.value);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const position = urlParams.get("position")
      ? decodeURIComponent(urlParams.get("position"))
      : null;
    if (position) {
      setPositionName(position);
    }
  }, []);

  useEffect(() => {
    if (!initialPageLoad.current) return;

    if (chosenFont?.decorative_svg) {
      setPositionName("Center");
      return;
    }

    setPositionName(monogramDefaultPosition);
  }, [chosenFont]);

  useEffect(() => {
    if (!initialPageLoad.current) return;
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("position", encodeURIComponent(positionName));
    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams}`);
  }, [positionName]);

  if (positions.length <= 1) {
    return null;
  }

  return (
    <div className="monogram-position__container">
      <MonogramSettingHeader title="Position" subtitle="Select Monogram Orientation" />
      <label className="sr-only" htmlFor={id}>
        Select a position
      </label>
      <div className="monogram-select">
        <select
          id={id}
          value={positionName}
          onChange={handleSelectChange}
          disabled={!!chosenFont?.decorative_svg}
        >
          {positions.map((position) => (
            <option value={position} key={`position-${position}`}>
              {position}
            </option>
          ))}
        </select>
        <Icon id="selectDownArrow" className="monogram-select__icon" />
      </div>
    </div>
  );
}

export default withMonogramContext(MonogramPositionDropdown);
